import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { OneActorT, UpdateActorT } from 'shared/api/types/services';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Update
export type UpdateFormT = UpdateActorT['request'] & {files?: File[]};
export const getUpdateValues = (values?: OneActorT['response']): UpdateFormT => ({
  name: values?.name,
  nick: values?.nick,
  prompt: values?.prompt,
  bio: values?.bio,
  files: [],
  photo: null,
});
const updateSchema: Yup.ObjectSchema<UpdateFormT> = Yup.object({
  name: Yup.string().required(),
  nick: Yup.string().required(),
  prompt: Yup.string().required(),
  bio: Yup.string().required(),
  files: Yup.array().of(Yup.mixed<File>()).optional(),
  photo: Yup.mixed<File>().optional().nullable() as FixMeLater,
});
export const updateResolver = yupResolver(updateSchema) as Resolver<UpdateFormT>;

// Create
export type CreateFormT = UpdateActorT['request'];
export const getCreateValues = (values?: OneActorT['response']): CreateFormT => ({
  name: values?.name,
  nick: values?.nick,
  prompt: values?.prompt,
  bio: values?.bio,
  photo: null,
});
const createSchema: Yup.ObjectSchema<CreateFormT> = Yup.object({
  name: Yup.string().required(),
  nick: Yup.string().required(),
  prompt: Yup.string().required(),
  bio: Yup.string().required(),
  photo: Yup.mixed<File>().optional().nullable() as FixMeLater,
});
export const createResolver = yupResolver(createSchema) as Resolver<CreateFormT>;